import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.image-marquee-cta__splide' ).length ) {
        $( '.image-marquee-cta__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            perPage: 3,
            gap: '2rem',
            arrows: false,
            pagination: false,
            breakpoints: {
              768: {
                perPage: 2,
              },
            },
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-marquee-cta', COMPONENT );
} )( app );
